import React, { useEffect, useState } from "react";
import './styles.css'
import LandingNavBar from "../landing-nav-bar/landingNavBar";
import { config } from "../../../config";
import { APP_CONSTANTS } from "../../../utils/AppConstants";
import { screenCaptureAnalytics } from "../../../utils/Utils";
import PageFooter from "../page-footer/pageFooter";

const FeaturePage = props => {
    const features = [
        {
            image: require('../../../assets/ic_feature_business.png'),
            title: "Unlimited Business Management",
            description: "Register and manage unlimited businesses, locations, and employees in one centralized platform"
        },
        {
            image: require('../../../assets/ic_feature_security.png'),
            title: "Role-Based Permissions",
            description: "Define precise permissions for each employee role with our feature access matrix. Restrict or enable specific functionalities based on requirements"
        },
        {
            image: require('../../../assets/ic_feature_attendance.png'),
            title: "Attendance & Shift Management",
            description: "Track employee attendance, create custom shifts, and monitor schedules in real-time"
        },
        {
            image: require('../../../assets/ic_feature_task.png'),
            title: "Task Management",
            description: "Assign, track, and prioritize tasks with deadline alerts and progress tracking"
        },
        {
            image: require('../../../assets/ic_feature_message.png'),
            title: "In-App Messaging",
            description: "Built-in communication tool for seamless team collaboration"
        },
        {
            image: require('../../../assets/ic_feature_document.png'),
            title: "Document Management",
            description: "Centralized storage for handbooks, and company documents with version control"
        },
        {
            image: require('../../../assets/ic_feature_asset.png'),
            title: "Assets Management",
            description: "Track company assets (laptops, mobiles, equipment) with assignment history and maintenance scheduling"
        },
        {
            image: require('../../../assets/ic_feature_hr.png'),
            title: "HR Management Suite",
            description: "Complete employee lifecycle management including onboarding, performance reviews, and policy management"
        },
        {
            image: require('../../../assets/ic_feature_payroll1.png'),
            title: "Payroll Management",
            description: "Automated salary calculations, tax compliance, and payslip generation with dynamic country/state-specific rules"
        },
        {
            image: require('../../../assets/ic_feature_visitor.png'),
            title: "Visitor Book",
            description: "Visitor registration with host/purpose tracking, ID verification, check-in/out logs, and visit duration recording"
        },
        {
            image: require('../../../assets/ic_feature_audit.png'),
            title: "Audit Management",
            description: "Full audit trails with user assignments, verification workflows, comments, and status tracking for compliance"
        },
        {
            image: require('../../../assets/ic_feature_supplies.png'),
            title: "Supplies Management",
            description: "Inventory tracking for office supplies with stock alerts, purchase orders, and departmental distribution"
        }
        // {
        //     title: "Reporting & Analytics",
        //     description: "Generate detailed reports on workforce productivity and business operations"
        // }
    ];

    useEffect(() => {
        if (config.environment === APP_CONSTANTS.ENVIRONMENT.PROD) {
            const data = {
                screen: 'FEATURE_PAGE',
                screenClass: 'FEATURE_PAGE'
            }
            screenCaptureAnalytics(data)
        }
    }, [])

    return (
        <>
            <LandingNavBar showHomeLink={true} />
            <div className="lp-hero-section">
                <h1 className="lp-title text-center">Empower Your Workforce at Every Scale — All Features, One Platform</h1>
                <p className="lp-sub-title text-center">From granular access controls to seamless team collaboration, Togethra combines enterprise-grade security with intuitive workforce management. Manage unlimited businesses, locations, and employees while automating attendance, tasks, and documentation — all backed by our risk-free 1-month trial with full functionality.</p>
                <div className="fp-feature-row-container">
                    {features.map(e => (<div className="fp-feature-row-item-container">
                        <div className="fp-fric-img-container">
                            <img src={e.image} className="img" alt="img" />
                        </div>
                        <div className="fp-fric-title">{e.title}</div>
                        <div className="fp-fric-subtext">{e.description}</div>
                    </div>))}

                </div>
            </div>
            <PageFooter isFeaturePage={true} />
        </>
    )
}

export default FeaturePage